<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_headerstock">
                <img :src="$props.img_header">
            </div>
            <h2 class="title_headerstock">{{ $props.header }}</h2>
        </div>

        <v-btn class="grad-primary-bg titlefont_headerstock d-none d-sm-flex white--text" height="50" width="20%" @click="$router.push('/'+$props.link_back)">
            ย้อนกลับ
        </v-btn>
        <v-btn class="grad-primary-bg titlefont_headerstock d-flex d-sm-none white--text" height="50" @click="$router.push('/'+$props.link_back)">
            ย้อนกลับ
        </v-btn>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            image:null
        }
    },
    props:['header','img_header','link_back'],
}
</script>

<style scoped>
    .title_headerstock{
        margin-left: 10px;
    }

    .img_title_headerstock{
        width: 50px;
    }

    .img_title_headerstock > img{
         max-width: 100%;
    }

    .titlefont_headerstock{
         font-size: 22px !important;
    }
</style>
